import { render, staticRenderFns } from "./AccommodationBlock.vue?vue&type=template&id=16ac49f6&scoped=true&"
import script from "./AccommodationBlock.vue?vue&type=script&lang=js&"
export * from "./AccommodationBlock.vue?vue&type=script&lang=js&"
import style0 from "./AccommodationBlock.vue?vue&type=style&index=0&id=16ac49f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16ac49f6",
  null
  
)

export default component.exports